module.exports = __webpack_public_path__ + "img/product-ABS.950843f4.svg";